import {Component, inject, input, Input} from '@angular/core';
import {SpinnerComponent} from "src/app/presentation/common/spinner/spinner.component";
import {NgOptimizedImage} from "@angular/common";
import {FathomService} from 'src/app/analytics/fathom.service';

@Component({
  selector: 'app-generic-button',
  host: {
    '[class.disabled]': 'disabled'
  },
  imports: [
    SpinnerComponent,
    NgOptimizedImage
  ],
  templateUrl: './generic-button.component.html',
  styleUrl: './generic-button.component.css'
})
export class GenericButtonComponent {

  buttonText = input.required<string>();
  description = input.required<string>();
  @Input() buttonClass: string = 'btn-info btn-info-shadow'
  @Input() primaryIcon?: string
  @Input() secondaryIcon?: string
  @Input() loading: boolean = false
  @Input() disabled: boolean = false
  @Input() stacked: boolean = false
  @Input() alwaysShowText: boolean = false

  private fathomService = inject(FathomService);

  onClick() {
    this.fathomService.trackEvent(this.description());
  }
}
